import { Loader2 } from 'lucide-react';

interface DashboardLoadingStateProps {
  message?: string;
  description?: string;
}

/**
 * A loading indicator designed for dashboard content areas.
 * Unlike the full-screen LoadingPlaceholder, this component is intended
 * to be rendered inside the dashboard content region while the page header
 * and toolbar remain visible.
 */
export function DashboardLoadingState({
  message = 'Loading...',
  description,
}: DashboardLoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <div className="relative mb-4">
        <div className="absolute inset-0 rounded-full bg-primary/10 animate-ping" />
        <div className="relative rounded-full bg-primary/5 p-3">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </div>
      <p className="text-sm font-medium text-muted-foreground">{message}</p>
      {description && (
        <p className="text-xs text-muted-foreground mt-1">{description}</p>
      )}
    </div>
  );
}
